/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import { useState } from 'react';
import { Box, Button, InfoIcon } from '@bottlebooks/gatsby-theme-base';

/**
 * @param {object} props
 * @param {object} props.pricing
 * @param {boolean} [props.showMorePricingInfo=false] Show more info toggle for price ranges
 * @returns
 */
export default function PriceRange({
  pricing,
  showMorePricingInfo = false,
  ...rest
}) {
  const [isVisible, toggleVisible] = useState(false);
  return (
    <Box>
      <span {...rest}>{pricing.priceRange}</span>
      <Button
        variant="text"
        onClick={() => {
          toggleVisible(!isVisible);
        }}
      >
        {showMorePricingInfo &&
          Boolean(pricing?.publicPriceRangeImage?.fixed) && (
            <InfoIcon sx={{ marginTop: -1 }} size="small" />
          )}
      </Button>
      {isVisible && (
        <Box>
          <img
            alt="Price range details"
            srcSet={pricing?.publicPriceRangeImage?.fixed?.srcSet}
            sx={{ maxWidth: '100%' }} // Prevent from running off mobile devices
          ></img>
        </Box>
      )}
    </Box>
  );
}
